/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { slug } from '../common';
import addActiveBookshelvesToHome from './extenders/addActiveBookshelvesToHome';
import addBookshelvesNav from './extenders/addBookshelvesNav';
import customizeArticlePage from './extenders/customizeArticlePage';
import customizeLiteraryWorkPage from './extenders/customizeLiteraryWorkPage';
import extendArticleSliderItem from './extenders/extendArticleSliderItem';
import extendArticleStatus from './extenders/extendArticleStatus';
import extendLiteraryWorkState from './extenders/extendLiteraryWorkState';
import setupRouting from './setupRouting';

app.initializers.add(
	slug,
	() => {
		addActiveBookshelvesToHome();
		addBookshelvesNav();
		customizeArticlePage();
		customizeLiteraryWorkPage();
		extendArticleSliderItem();
		extendArticleStatus();
		extendLiteraryWorkState();
		setupRouting();
	},
	-1
);

import bookshelfCompat from './compat';
import { compat } from '@flarum/core/forum';

Object.assign(compat, bookshelfCompat);

export { default as extend } from './extend';
